import { MainNav } from "@portal/components/ui/MainNav";

export const AdminMainNav = () => (
	<MainNav
		label="Underwriter"
		smallLabel="U/W"
		items={{
			dashboard: true,
			requests: true,
			bonds: true,
			accounts: true,
			submissions: true,
			marketAnalytics: true,
		}}
	/>
);
